import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../customHooks/useDeleteHook";

const ChartsOfAccountsComponents = loadable(
  () => import("../../components/ChartsOfAccounts/")
);

export default () => {
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["charts-of-account"],
  });

  const handleDelete = async (id: any) => {
    const url = `${APIS.COA}${id}/`;
    try {
      await mutateAsync({ url, setError: () => {} });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw``}>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Chart Of Accounts
        </h1>
      </div>
      <ChartsOfAccountsComponents
        handleDelete={handleDelete}
        isLoading={isLoading}
      />
    </div>
  );
};
